import { animated, useInView } from '@react-spring/web';
import { StyleSheet, Text, View } from 'react-native';
import React from 'react';
import CardReceiveIcon from '../../../components/Icons/CardReceiveIcon';

const styles = StyleSheet.create({
  emptyListStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 36,
    flex: 1,
    width: '100%',
    height: '100%',
    padding: 36
  },
  emptyListTextStyle: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flex: 1
  },
  emptyListMessageTitleStyle: {
    fontSize: 24,
    fontWeight: 700,
    textAlign: 'center'
  },
  emptyListMessageSubtitleStyle: {
    fontSize: 18,
    color: '#999',
    textAlign: 'center'
  },
  onboardButton: {
    paddingTop: 16,
    paddingRight: 24,
    paddingBottom: 16,
    paddingLeft: 24,
    backgroundColor: 'rgb(41, 45, 50)',
    borderRadius: 6,
    color: '#fff',
    textAlign: 'center',
    boxShadow: '1px 2px 4px rgba(41, 45, 50, 0.5)'
  },
  onboardButtonText: {
    color: 'inherit',
    fontSize: 16
  }
});

const AddingToWallet: React.FC = () => {
  // Icon Animation
  const [iconAnim, iconAnimStyle] = useInView(() => ({
    from: {
      opacity: 0,
      transform: 'translateY(40px)'
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)'
    }
  }));

  // Text Animation
  const [textAnim, textAnimStyle] = useInView(() => ({
    from: {
      opacity: 0,
      transform: 'translateY(40px)'
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
      delay: 100
    }
  }));

  return (
    <View style={styles.emptyListStyle}>
      <View>
        <animated.div ref={iconAnim} style={iconAnimStyle}>
          <CardReceiveIcon iconWidth={140} iconHeight={140}></CardReceiveIcon>
        </animated.div>
      </View>

      <View>
        <animated.div ref={textAnim} style={textAnimStyle}>
          <View style={styles.emptyListTextStyle}>
            <Text style={styles.emptyListMessageTitleStyle}>
              Adding credential<br></br> to your wallet...
            </Text>
            <Text style={styles.emptyListMessageSubtitleStyle}>
              This might take a few moments. Please wait.
            </Text>
          </View>
        </animated.div>
      </View>
    </View>
  );
};
export default AddingToWallet;
